import { render } from "./ReadArticleView.vue?vue&type=template&id=04183d90&scoped=true"
import script from "./ReadArticleView.vue?vue&type=script&lang=js"
export * from "./ReadArticleView.vue?vue&type=script&lang=js"

import "./ReadArticleView.vue?vue&type=style&index=0&id=04183d90&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04183d90"]])

export default __exports__